import { render, staticRenderFns } from "./PsPatientsList.vue?vue&type=template&id=29049cf8&scoped=true&"
import script from "./PsPatientsList.vue?vue&type=script&lang=js&"
export * from "./PsPatientsList.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientsList.vue?vue&type=style&index=0&id=29049cf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29049cf8",
  null
  
)

export default component.exports